import { Stack } from '@mui/material';
import { ConditionTypeChip } from './ConditionTypeChip';
import { CalculusArea, GroupedConditions } from '@retail/calculus/types';

interface Props {
  draftConditions?: GroupedConditions;
}

export function DraftConditionCountChips({ draftConditions }: Props) {
  const conditions = draftConditions?.conditions ?? [];

  const getTypeCount = (type: CalculusArea) =>
    conditions.filter((condition) =>
      condition.condition.types.map((type) => type.type).includes(type)
    ).length;

  const purchaseConditionCount = getTypeCount('PURCHASE');
  const freightConditionCount = getTypeCount('FREIGHT');
  const markupConditionCount = getTypeCount('MARKUP');
  const priceSourceConditionCount = getTypeCount('PRICE_SOURCE');
  const customerMarkupConditionCount = getTypeCount('CUSTOMER_MARKUP');
  const roundingConditionCount = getTypeCount('ROUNDING');

  return (
    <Stack flexDirection="row" gap={1}>
      {!!purchaseConditionCount && (
        <ConditionTypeChip
          calculusArea="PURCHASE"
          customLabel={purchaseConditionCount + ''}
          width={38}
          rounded
        />
      )}
      {!!freightConditionCount && (
        <ConditionTypeChip
          calculusArea="FREIGHT"
          customLabel={freightConditionCount + ''}
          width={38}
          rounded
        />
      )}
      {!!markupConditionCount && (
        <ConditionTypeChip
          calculusArea="MARKUP"
          customLabel={markupConditionCount + ''}
          width={38}
          rounded
        />
      )}
      {!!priceSourceConditionCount && (
        <ConditionTypeChip
          calculusArea="PRICE_SUGGESTION"
          customLabel={priceSourceConditionCount + ''}
          width={38}
          rounded
        />
      )}
      {!!customerMarkupConditionCount && (
        <ConditionTypeChip
          calculusArea="CUSTOMER_MARKUP"
          customLabel={customerMarkupConditionCount + ''}
          width={38}
          rounded
        />
      )}
      {!!roundingConditionCount && (
        <ConditionTypeChip
          calculusArea="ROUNDING"
          customLabel={roundingConditionCount + ''}
          width={38}
          rounded
        />
      )}
    </Stack>
  );
}
